export default __webpack_public_path__ + "static/media/kit_and_app.3b2c8498.png";